import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {switchMap, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {AuthServiceProvider} from "../../../services/col2/auth.service";
import {FunctionalAccessService} from "../../../services/functional-access.service";
import {V3School} from "../../../model/v3/schools";
import {SchoolV3RestService} from "../../../services/rest/v3/school-rest.service";

@Component({
    selector: 'app-admin-school-dashboard',
    templateUrl: './admin-school-dashboard.component.html',
    styleUrls: ['./admin-school-dashboard.component.scss'],
    standalone: false
})
export class AdminSchoolDashboardComponent implements OnInit {

  school: V3School
  schoolId: number

  constructor(
    private schoolV3Rest: SchoolV3RestService,
    private route: ActivatedRoute,
    private authProvider: AuthServiceProvider,
    private functionalAccessService: FunctionalAccessService
  ) {}

  ngOnInit(): void {
    this.route.parent.paramMap.pipe(
      tap(params => this.schoolId = +params.get("schoolId")),
      switchMap(_ => this.schoolV3Rest.getSchool(this.schoolId))
    ).subscribe(school => (this.school = school))
  }

  redirectTo(path: string) {
      this.logInAsManager(path).subscribe()
  }

  logInAsManager(path: string): Observable<any> {
    return this.authProvider
      .get()
      .pipe(
        tap((auth) => auth.logInAsManager(this.schoolId, path)),
        //reinitialize functionalAccess when admin has manager school id
        tap(_ => this.functionalAccessService.initialize())
      )
  }
}
